import DateRangeFilter from 'components/Reporting/Shared/Filters/OverviewDateRange'
import ProjectTags from 'components/Reporting/Overview/FilterBuilder/Filters/ProjectTags'
import ProjectStatus from 'components/Reporting/Overview/FilterBuilder/Filters/ProjectStatus'
import Projects from 'components/Reporting/Overview/FilterBuilder/Filters/Projects'
import Pages from 'components/Reporting/Overview/FilterBuilder/Filters/Pages'
import Hubs from 'components/Reporting/Overview/FilterBuilder/Filters/Hubs'
import ParticipantTypes from 'components/Reporting/Overview/FilterBuilder/Filters/ParticipantTypes'
import ParticipantGroups from 'components/Reporting/Overview/FilterBuilder/Filters/ParticipantGroups'
import Location from 'components/Reporting/Overview/FilterBuilder/Filters/Location'
import YearsOfBirth from 'components/Reporting/Overview/FilterBuilder/Filters/YearsOfBirth'
import Ethnicity from 'components/Reporting/Overview/FilterBuilder/Filters/Ethnicity'
import Gender from 'components/Reporting/Overview/FilterBuilder/Filters/Gender'

export const Components: any = {
  DateRangeFilter,
  ProjectStatus,
  ProjectTags,
  Projects,
  Pages,
  Hubs,
  ParticipantTypes,
  ParticipantGroups,
  Location,
  YearsOfBirth,
  Ethnicity,
  Gender,
}
